@if (machineStructureIsLoading){
    <dx-tree-list
        [height]="height"
        [dataSource]="machineStructure"
        [showRowLines]="true"
        [showBorders]="true"
        [showColumnLines]="true"
        [rowAlternationEnabled]="false"
        [expandedRowKeys]="[1]"
        filterMode="fullBranch"
        dataStructure="tree"
        itemsExpr="items"
        class="machine-structure-tree-list"
    >
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-scrolling mode="standard"></dxo-scrolling>

        <dxi-column dataField="structureName" [caption]="'machine-structure-caption' | translateWithFallback"></dxi-column>
        <dxi-column dataField="valueId" [caption]="'machine-structure-value-caption' | translateWithFallback" cellTemplate="customCellTemplate" [allowFiltering]="false"></dxi-column>
        <div *dxTemplate="let options of 'customCellTemplate'">
            <span class="value-text">{{ getObservableValue(options.data.valueId) | async }}</span>
        </div>
    </dx-tree-list>
}
@else {
    <div>
        <span>{{'machine-structure-not-available' | translateWithFallback}}</span>
    </div>
}